import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { first, find, filter } from 'lodash';
import { Tab, Nav, NavItem } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { getPredefineDateRanges } from '../../util/helpers';
import styles from './styles.css';


class PredefinedRangeSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      predefinedRanges: props.predefinedRanges || getPredefineDateRanges(),
    };
    this.selectRange = this.selectRange.bind(this);
  }


  selectRange(range) {
    this.props.selectRange(range);
  }

  render() {
    const { predefinedRanges } = this.state;
    const { selectedRanges, includeFuturePredefinedRanges } = this.props;

    const availableRanges = filter(predefinedRanges, (predefinedRange) => {
      if (includeFuturePredefinedRanges) {
        return predefinedRange.isFuture;
      }
      return true;
    });

    const firstSelected = first(selectedRanges);
    const defaultSelected = first(availableRanges);

    let defaultActiveKey = null;
    if (firstSelected) {
      defaultActiveKey = firstSelected.label;
    }
    if (!defaultActiveKey && defaultSelected) {
      defaultActiveKey = defaultSelected.label;
    }
    return (
      <div className={styles.predefinedRanges}>
        <Tab.Container
          id="predefined-range-selector"
          defaultActiveKey={defaultActiveKey}
        >
          <div className="row">
            <div className={`col-xs-6 col-sm-4 ${styles.predefinedRangesNav}`}>
              <Nav bsStyle="pills" stacked>
                {availableRanges.map((predefinedRange) => {
                  const active = firstSelected ? firstSelected.label === predefinedRange.label : false;
                  return (
                    <NavItem eventKey={predefinedRange.label} key={predefinedRange.label}>
                      {predefinedRange.label} {active && <Fa name="check" />}
                    </NavItem>
                  );
                })}
              </Nav>
            </div>
            <div className={`col-xs-6 col-sm-8 ${styles.predefinedRangesContent}`}>
              <Tab.Content>
                {availableRanges.map((predefinedRange) => {
                  const selectedRange = find(selectedRanges, { label: predefinedRange.label });
                  return (
                    <Tab.Pane eventKey={predefinedRange.label} key={predefinedRange.label}>
                      <ul className="nav nav-pills nav-stacked">
                        {predefinedRange.ranges.map((range) => {
                          let active = false;
                          if (selectedRange) {
                            const r = find(selectedRange.ranges, { slug: range.slug });
                            if (r) {
                              active = true;
                            }
                          }
                          return (
                            <li
                              key={range.label}
                              className={active ? 'active' : ''}
                            >
                              <a
                                style={{ fontWeight: active ? 'bold' : '' }}
                                href=""
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.selectRange(range);
                                }}
                                className={active ? 'text-success' : ''}
                              >
                                {range.label}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    </Tab.Pane>
                  );
                })}
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    );
  }
}

PredefinedRangeSelector.propTypes = {
  selectRange: PropTypes.func,
  includeFuturePredefinedRanges: PropTypes.bool,
  predefinedRanges: PropTypes.arrayOf(PropTypes.shape({})),
  selectedRanges: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    ranges: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      slug: PropTypes.string,
      displayLabel: PropTypes.string,
    })),
  })),
};
PredefinedRangeSelector.defaultProps = {
  selectRange: () => {},
  selectedRanges: [],
  predefinedRanges: null,
  includeFuturePredefinedRanges: false,
};
export default PredefinedRangeSelector;
